// @ts-nocheck
import * as React from "react";
import { Ic } from "../screens/common";
import { useEscapeKey } from "./useEscapeKey";

// 권역 관리자가 추천 후보를 "배정(accepted)" 또는 "보류(hold)" 결정 직전에
// 한 번 확인하는 모달. 거절(rejected)은 사유 입력이 필수라 별도의
// RejectMatchModal을 그대로 쓴다 — 두 결정은 결과/되돌릴 수 있는 정도가
// 달라 한 컴포넌트에 강제 통합하면 분기가 더 더러워진다.
//
// 메모는 선택 입력 — 입력 시 백엔드가 audit_logs.meta로 보존한다
// (matches_controller.rb#decide의 `note` 파라미터와 동일 경로).
const CONFIG = {
  accepted: {
    title:    "매니저 배정 확정",
    summary:  "이 매니저를 배정하면 케이스 상태가 '배정 완료'로 바뀌고, 같은 케이스의 다른 후보는 자동으로 보류됩니다.",
    notePlaceholder: "배정 메모 (선택)",
    confirmLabel: "배정 확정",
    confirmBg:    "var(--green-600, #16a34a)",
    badgeColor:   "green",
    badgeLabel:   "배정",
  },
  hold: {
    title:    "후보 보류",
    summary:  "후보를 일단 보류합니다. 인박스에서 회색으로 표시되며 추후 다시 결정할 수 있습니다. 케이스 자체는 매칭 상태로 유지됩니다.",
    notePlaceholder: "보류 사유 (선택)",
    confirmLabel: "보류 확정",
    confirmBg:    "var(--ink-3, #6b7280)",
    badgeColor:   "gray",
    badgeLabel:   "보류",
  },
};

export function ConfirmMatchDecisionModal({ match, decision, onClose, onConfirm, busy = false, err = null }) {
  useEscapeKey(busy ? () => {} : onClose);
  const cfg = CONFIG[decision] || CONFIG.accepted;
  const [note, setNote] = React.useState("");
  const noteRef = React.useRef(null);

  React.useEffect(() => {
    // 모달이 뜬 직후 메모 포커스 — 타이핑 없이 Enter만 쳐도 확정되도록.
    noteRef.current?.focus();
  }, []);

  const submit = (e) => {
    if (e) e.preventDefault();
    if (busy) return;
    onConfirm({ note: note.trim() });
  };

  const cm = match.care_manager;

  return (
    <div onClick={busy ? undefined : onClose}
      style={{position:'fixed', inset:0, background:'rgba(20,16,12,0.4)', display:'grid', placeItems:'center', zIndex:50}}>
      <form onSubmit={submit} onClick={e=>e.stopPropagation()} className="card" style={{width:480, padding:0}}>
        <div style={{padding:'16px 22px', borderBottom:'1px solid var(--border-soft)', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
          <div>
            <div className="h3" style={{display:'flex', alignItems:'center', gap:8}}>
              {cfg.title}
              <span className={"badge badge-" + cfg.badgeColor} style={{fontSize:10.5}}>{cfg.badgeLabel}</span>
            </div>
            <div className="muted" style={{fontSize:11, marginTop:2}}>
              {cm.name} · {cm.qualification} · 매칭 점수 {match.score}
            </div>
          </div>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose} disabled={busy}>{Ic.close}</button>
        </div>

        {err && (
          <div style={{margin:'14px 22px 0', padding:'10px 14px', background:'var(--rose-50)', color:'var(--rose-500)', borderRadius:10, fontSize:12.5}}>
            {err}
          </div>
        )}

        <div style={{padding:22, display:'grid', gap:10}}>
          <div style={{fontSize:13, color:'var(--ink-1)', lineHeight:1.55}}>
            {cfg.summary}
          </div>

          <div className="label" style={{marginTop:4}}>
            메모 <span className="muted" style={{fontWeight:400, fontSize:10.5}}>(선택 · 감사 로그에 기록됩니다)</span>
          </div>
          <textarea
            ref={noteRef}
            className="input"
            rows={3}
            value={note}
            onChange={e=>setNote(e.target.value)}
            placeholder={cfg.notePlaceholder}
            style={{resize:'vertical', minHeight:72}}
            disabled={busy}
          />
        </div>

        <div style={{padding:'14px 22px', borderTop:'1px solid var(--border-soft)', display:'flex', justifyContent:'flex-end', gap:8}}>
          <button type="button" className="btn btn-ghost btn-md" onClick={onClose} disabled={busy}>취소</button>
          <button type="submit" className="btn btn-primary btn-md" disabled={busy}
            style={{background: cfg.confirmBg}}>
            {busy ? '처리 중…' : cfg.confirmLabel}
          </button>
        </div>
      </form>
    </div>
  );
}
